import { deleteObject, getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";

export async function uploadUserProfileImage(uuid: string, file: File): Promise<string> {
  const allowTypes = ['image/png', 'image/jpeg']
  if (!allowTypes.some(it => it === file.type)) throw new Error('not allowed type.')
  
  const userProfileRef = ref(storage, `images/users/${uuid}/profile.${file.type.split("/")[0]}`)
  await uploadBytes(userProfileRef, file)
  return await getDownloadURL(userProfileRef)
}

export async function removeUserProfileImage(uuid: string) {
  const userRef = ref(storage, `images/users/${uuid}/`)
  const fileList = await listAll(userRef)
  fileList.items.forEach(it => deleteObject(it))
}